var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 3.33301L4.00033 -0.00032568L7.33366 3.33301H0.666992Z",
    fill: "#205274"
  })));
}
export default __webpack_public_path__ + "static/media/new-arrow-up.5b441766.svg";
export { SvgNewArrowUp as ReactComponent };